import { Injectable } from '@angular/core';
import { PoOrderSupply } from './po-order-supply';
import {  HttpGeneralService, StockParms } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
let poOrderSupplyUrl = CONFIG.baseUrls.PoOrderSupply; 
let supplierServicesUrl = CONFIG.baseUrls.supplierServices;
let stockTransUrl = CONFIG.baseUrls.StockTrans;


@Injectable()
export class poOrderSupplyDetailService {

  constructor(private httpGeneralService: HttpGeneralService ,private _http: HttpClient) { }

  addpoOrderSupply(poOrderSupply: PoOrderSupply) {
    return this.httpGeneralService.add<PoOrderSupply>(poOrderSupply, poOrderSupplyUrl);
  }
  deletepoOrderSupply(poOrderSupply) {
    return this.httpGeneralService.delete(poOrderSupply.serial, poOrderSupplyUrl);
  }
  getAllRequestNeeded(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${poOrderSupplyUrl}/GetAllRequestsNeeded`);
    //data[0]
  }
  getAllOfferPrice(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${poOrderSupplyUrl}/GetAllOfferPrice`);
    //data[0]
  }


  getItemsForTenders(SerialsArr: string,QueryCode:number) {
    return this.httpGeneralService.getWith(`${poOrderSupplyUrl}/${SerialsArr}/${QueryCode}/GetItemsForTenderRequest`)
  }

  getAllItemsByPoOrderSupply(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${poOrderSupplyUrl}/getAllItemsByPoOrderSupply`);
  }

  getAllSupplierService(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${poOrderSupplyUrl}/getAllSupplierService`);
  }
  getAllItemsByREquestOrder(itemCodes: any) {
    return this.httpGeneralService.getWith(`${poOrderSupplyUrl}/${itemCodes}/GetItems`);
    //data[0]
  }

  addServiceToSupplier(g) {
    return this.httpGeneralService.add(g, `${supplierServicesUrl}/SupSupplierServices`);
  }
 getItems(itemCodes: string) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/${itemCodes}`)
  }

  itemsLoad(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/itemsLoad`);
    //data[0]
  }



  getAllPoOrderSuppExpenses(PoOrderSerial) {
    return this.httpGeneralService.getWith(`${poOrderSupplyUrl}/${PoOrderSerial}/getAllPoOrderSuppExpenses`);
  }

  public getJSON(): Observable<any> {
    return this._http.get("../../../setting/StockTransSetting_1.json");
  }
  
}
